"use client";

import { useEffect, useRef } from "react";

import { usePathname } from "next/navigation";

export function NavigationProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const pathname = usePathname();
  const isFirstLoad = useRef(true);

  useEffect(() => {
    // Reset transition state on initial load
    document.documentElement.classList.remove("page-transition");

    // Skip transition on first load
    if (isFirstLoad.current) {
      isFirstLoad.current = false;
      return;
    }

  }, [pathname]); // Re-run effect when the route changes

  return <>{children}</>;
}
